import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getTypeCardBasePath } from '@/react-query/common';

import { Card, VirtualCard } from '@generated-types';
import { cardTypeGet } from '@utils/query-utils';

import { decryptVirtualCardMessage } from './decryptVirtualCardMessage';

const getVirtualCard = async (card: Card) =>
    cardTypeGet(
        card.type,
        false,
    )<VirtualCard>(`${getTypeCardBasePath(card.type)}/${card.id}/virtual`).then((digitalCard) => {
        const { message } = digitalCard;
        const decipheredMessage = decryptVirtualCardMessage(card.number, message);
        return { ...digitalCard, message: decipheredMessage };
    });

export const useTeVirtualCard = (
    card: Card,
    options?: Omit<UseQueryOptions<VirtualCard | undefined>, 'queryKey' | 'queryFn'>,
) => {
    const isAllowed = card.allowedOperations.getVirtualCard;

    return useQuery<VirtualCard | undefined>({
        ...options,
        queryKey: ['virtualCard', card],
        queryFn: () => getVirtualCard(card),
        enabled: !!card && isAllowed && options?.enabled,
        retry: false,
    });
};
